import vine from '@vinejs/vine'
import { orgRichTextVine } from '~/validators/orgRichText'
import { createAndUpdateValidator, optionalLongLabelField, orgLibField } from '~/validators/orgFields'

const domaineValidators = createAndUpdateValidator(function domaineSchema() {
  return vine.object({
    dirLib: orgLibField(),
    domLib: orgLibField(),
    domLibLong: optionalLongLabelField(),
    domDesc: orgRichTextVine().nullable(),
  })
})

export const createDomaineValidator = domaineValidators.create
export const updateDomaineValidator = domaineValidators.update

export const patchDomaineValidator = vine.create(
  vine.object({
    dirLib: orgLibField().nullable().optional(),
    domLib: orgLibField().nullable().optional(),
    domLibLong: optionalLongLabelField(),
    domDesc: orgRichTextVine().nullable().optional(),
  })
)
